import '../plugins/MobileNavPlugin.js';
import '../plugins/ResponsiveHelper.js';

// mobile menu init
export default function initMobileNav() {
	ResponsiveHelper.addRange({
		'..1024': {
			on: function() {
				jQuery('body').mobileNav({
					menuActiveClass: 'nav-active',
					menuOpener: '.nav-opener',
					onShow: () => {
						jQuery('.wrap-mobile-drop').scrollTop(0);
					}
				});
			},
			off: function() {
				jQuery('body').mobileNav('destroy');
			}
		}
	});

	jQuery('body').mobileNav({
		menuActiveClass: 'filters-active',
		menuOpener: '.filters-main-opener, .filters-close'
	});

	function hideDrop(e) {
		e.preventDefault();

		const lvl2 = e.currentTarget.classList.contains('lvl2');
		const $dropItem = jQuery(e.currentTarget).closest(lvl2 ? '.sub-menu' : '.nav-item');
		const $dropToggle = $dropItem.find('.dropdown-toggle.show');

		if (bootstrap && bootstrap.Dropdown) {
			bootstrap.Dropdown.getOrCreateInstance($dropToggle).hide();
		}
	}

	jQuery(document).on('click', '.btn-level-back', hideDrop);
}
